import { ShopImportDto } from "@babackapp/private-api-client/types";
import { z } from "zod";
import { ShopImportFormValuesSchema } from "../components/import-settings/import-settings-form-types";

export function mappingFormSchemaToMappingDto(
  mapping: z.infer<typeof ShopImportFormValuesSchema>["mapping"],
): ShopImportDto["mapping"] {
  const mappingDto: ShopImportDto["mapping"] = {};
  mapping.forEach((item) => {
    if (item.mapTo) {
      if (item.mapTo === "resultColumn") {
        mappingDto.resultColumn = {
          columnNumber: item.fieldIndex,
          regexSuccess: item.regexSuccess || "",
        };
      } else {
        mappingDto[item.mapTo] = item.fieldIndex;
      }
    }
  });
  return mappingDto;
}